import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { ISupportAccessSession, ISupportFeedback, ISupportRequest } from '@models/supportAccess/supportAccess.types';

const base = '/supportSessions';

/**
 * Запросы поддержки к пользователю и его история доступа поддержки (IMPLEMENTATION.md §15). Во вкладке «от имени»
 * сервер их запрещает: решать за пользователя и читать его историю сотрудник не может.
 */
export class SupportAccessService {
    /** Опрос в фоне: отказ не показывается тостом, плашки просто не меняются. */
    static fetchRequests(): Promise<AxiosResponse<ISupportRequest[]>> {
        return $api.get<ISupportRequest[]>(`${base}/requests`, {
            suppressErrorNotification: true,
            skipSupportErrorLog: true,
        });
    }

    /** Согласие на вход от имени; приглашение к показу принимает хаб (`StartWith`), не этот запрос. */
    static accept(id: string): Promise<AxiosResponse<void>> {
        return $api.post<void>(`${base}/requests/${encodeURIComponent(id)}/accept`);
    }

    static decline(id: string): Promise<AxiosResponse<void>> {
        return $api.post<void>(`${base}/requests/${encodeURIComponent(id)}/decline`);
    }

    /** Отказ показывает сам раздел настроек. */
    static fetchMine(): Promise<AxiosResponse<ISupportAccessSession[]>> {
        return $api.get<ISupportAccessSession[]>(`${base}/mine`, { suppressErrorNotification: true });
    }

    /** Оценка показа (§33); отказ показывает сама плашка оценки. */
    static sendFeedback(feedback: ISupportFeedback): Promise<AxiosResponse<void>> {
        return $api.post<void>(`${base}/feedback`, feedback, { suppressErrorNotification: true });
    }
}
